export default __webpack_public_path__ + "static/media/white-long-up-arrow-icon.4f2cae61.svg";